import { observable, makeObservable } from 'mobx';
import { raw, createModelSchema, primitive, object } from 'serializr';

import { optional } from '@vromo/models';

import { Upload } from '@vromo/models';



export class BrandColors {

    header = '#FFFFFF';
    /** bg color */
    background = '#FFFFFF';
    /** accent color */
    accent = '#189BF3';
    /** svg map icon for driver, url*/
    icon: Upload | null = null;
    /** feature for custom svg map icon for driver */
    enabled = false;
    /** svg map icon for driver, raw ? */
    map: any = [];
    customCss = '';

    constructor() {
        makeObservable(this, {
            enabled: observable,
            background: observable,
            header: observable,
            accent: observable,
            icon: observable,
            map: observable,
            customCss: observable
        });
    }
}

createModelSchema(BrandColors, {
    enabled: primitive(),
    background: primitive(),
    header: primitive(),
    accent: primitive(),
    icon: optional(object(Upload)),
    map: raw(),
    customCss: primitive()
});
